import projectConfig from '~/projects/config';

const LEGAL_LAST_UPDATED = 'April 1, 2026';

export const legalMarkdownVariables = {
  COMPANY_LEGAL_ADDRESS:
    'Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
  COMPANY_LEGAL_NAME: 'AV Wellbeing',
  EFFECTIVE_DATE: LEGAL_LAST_UPDATED,
  LAST_UPDATED: LEGAL_LAST_UPDATED,
  SITE_NAME: projectConfig.getProjectName(),
  SUPPORT_EMAIL: projectConfig.getSupportEmail(),
  SUPPORT_PHONE_US: '+1 (606) 517-7648',
  WEBSITE_URL: process.env.SITE_BASE_URL || '',
};
